import Head from "next/head";
import dynamic from "next/dynamic";
import { maxString } from "../../js/config/helpers";
import PageContextWrapper from "@components/Components/Reusables/PageContextWrapper";

const LandingPageLayout = dynamic(() => import("../../js/Components/LandingPages/LandingPageLayout"));

const area = ({ data , new_data}) => {

    const {
        place
    } = data;

    return (
        <>
            <Head>
                <title>{place.meta_title}</title>
                <meta
                    name="description"
                    content={maxString(place.meta_desc, 154)}
                />
            </Head>
            <PageContextWrapper
                page='landing'
                page_content={data.template_page_content}
            >
                <LandingPageLayout {...data} new_data ={new_data}/> 
            </PageContextWrapper>
        </>
    );
};

export async function getStaticProps({params}) {
    const {slug} = params;
    
    try {
        const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}get-area/${slug}`);
        const request = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}get-home-content`);
        const new_data = await request.json()
        const data = await req.json()
    
        if(data.exception || new_data.exception) {
            return {notFound: true}
        }
        
        return {
            props: {
                data, new_data
             },
             revalidate: (1000 * 60)
        };
        
    } catch (error) {
        return {notFound: true} //404
    }
}

export async function getStaticPaths() {
    return {
      paths: [],
      fallback: 'blocking',
    }
}


export default area;
